export default "__VITE_ASSET__CJk_$hxp__"